// import {Logger} from '@vanti/vue-logger';
// const log = Logger.get('offline');

/**
 * A module to track whether a panel is currently online or offline
 * If a panel is offline, we can use this module to alert the user and make other changes
 */
export default {
  namespaced: true,
  state: {
    // Whether the app is currently online or not
    onlineStatus: navigator.onLine,
    justBackOnline: false
  },
  mutations: {
    changeOnlineStatus(state, newStatus) {
      state.onlineStatus = newStatus;
    },
    changeJustBackOnline(state, newValue) {
      state.justBackOnline = newValue;
    }
  },
  actions: {
    setUp({dispatch}) {
      // These will track whether the user is currently online or offline
      window.addEventListener('online', () => {
        dispatch(`updateOnlineStatus`, 'online');
      });
      window.addEventListener('offline', () => {
        dispatch(`updateOnlineStatus`, 'offline');
      });
    },
    init: {
      root: true,
      handler({dispatch}) {
        return dispatch('setUp');
      }
    },
    // https://stackoverflow.com/a/51691000/3212929
    /**
     * A function to handle what happens when the user's online status changes
     * @param {function} commit
     * @param {String} newOnlineStatus - Either 'online' or 'offline'
     */
    updateOnlineStatus({commit, state}, newOnlineStatus) {
      // This will check if we are online value based on the function argument
      if (newOnlineStatus === 'online') {
        // Here, we can add functionality for when we get back online

        // Change the stored variables
        commit('changeOnlineStatus', true);
        commit('changeJustBackOnline', true);
      } else {
        commit('changeOnlineStatus', false);
      }
    }
  }
};
